export default __webpack_public_path__ + "static/media/san-rafael-15.6330b4d6.jpg";